import React, { Component } from "react";
import { loginInnova, getCookie, decodeToken } from "../functions.js";
import { Link, Redirect } from "react-router-dom";
import "./login-asesor-v2.css";
class LoginModal extends Component {
  constructor(props) {
    super(props);
    // Estado para almacenar los valores de usuario y contraseña
    this.state = {
      username: "",
      password: "",
      isModalOpen: false, // Modal está abierto por defecto
    };
  }

  // Método que se llama al hacer login
  login = async () => {
    var resp = await loginInnova(this.state.username, this.state.password);
    if (resp.success) {
      //console.log(resp)
      if (
        resp.user.valor1 === "Consultorio" ||
        resp.user.valor1 === "Monitor"
      ) {
        this.setState({ ...this.state, goHomeC: true });
      } else if (resp.user.valor1 === "Doctor") {
        this.setState({ ...this.state, goHomeD: true });
      } else {
        this.setState({ ...this.state, goHome: true });
      }

      window.location.reload();
    } else {
      this.setState({
        ...this.state,
        errorLogin: true,
        errorMessage: resp.error,
      });
    }
  };

  // Método que se llama cuando el componente se monta (al cargar la página)
  componentDidMount = async () => {
    console.log("login v2.0");

    let rol = getCookie("rolINNOVA2");
    let token = getCookie("tokenINNOVA2");
    if (token) {
      if (rol === "Consultorio" || rol === "Monitor") {
        this.setState({ ...this.state, goHomeC: true });
      }
      if (rol === "Doctor") {
        this.setState({ ...this.state, goHomeD: true });
      }
      if (rol === "Administrador") {
        this.setState({ ...this.state, goHomeA: true });
      }

      console.log("rol:", rol);
    } else {
      this.setState({ ...this.state, isModalOpen: true });
    }
  };
 

  // Función para manejar el cambio en los inputs
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    const { username, password, isModalOpen } = this.state;

    return (
      <>
        {this.state.goHome && <Redirect to={{ pathname: "/" }} />}

        {this.state.goHomeC && <Redirect to={{ pathname: "/reservation" }} />}

        {this.state.goHomeA && <Redirect to={{ pathname: "/manageusers" }} />}

        {this.state.goHomeD && (
          <Redirect to={{ pathname: "/doctor-dashboard" }} />
        )}
        <div style={{ minHeight: 480 }}>
          {isModalOpen && (
            <div className="c-modal">
              <div className="c-modal-content">
                <h2>Iniciar sesión - Monitor</h2>
                <input
                  type="text"
                  name="username"
                  value={username}
                  onChange={this.handleInputChange}
                  placeholder="Nombre de usuario"
                  autoFocus
                />
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.handleInputChange}
                  placeholder="Contraseña"
                />
                <button onClick={this.login}>Ingresar</button>{" "}
                {/* Botón para hacer login */}

                <div>
                {this.state.errorLogin ? (
                  <div className="row mt-3">
                    <div className="col-12">
                      <div
                        className="alert alert-danger alert-dismissible fade show"
                        role="alert"
                      >
                        <div>
                          <span> {this.state.errorMessage}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              </div>

             
            </div>
          )}
        </div>
      </>
    );
  }
}

export default LoginModal;
